'use client';

import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

import { CONFIG } from 'src/global-config';

// ----------------------------------------------------------------------

export function useReCaptcha() {
  const { executeRecaptcha } = useGoogleReCaptcha();

  const verifyCaptcha = async () => {
    if (executeRecaptcha) {
      const token = await executeRecaptcha('onSubmit');
      if (token) {
        return fetch(`/api/captcha?secret=${CONFIG.recaptcha.secretKey}&response=${token}`)
          .then((response) => response.json())
          .then((data) => data.score > 0.5)
          .catch((error) => {
            console.error('ReCaptcha data could not be loaded:', error);
            return false;
          });
      } else {
        console.error('ReCaptcha token could not be generated');
        return false;
      }
    } else {
      console.error('ReCaptcha could not be executed');
      return false;
    }
  };

  return verifyCaptcha;
}
